<template>
  <v-dialog :value="isModalActive" max-width="440" persistent>
    <v-card
      id="privacy-policy-modal"
      class="pb-5"
      :color="$vuetify.theme.dark ? 'dark_backgroundDarkBlue' : undefined"
    >
      <div class="mt-0 pt-1 px-6 pr-8">
        <div class="items-flex justify-between mt-4 mr-1">
          <div>
            <language-selector />
          </div>
          <div>
            <a
              :class="{
                'darkTextGrey--text': !$vuetify.theme.dark,
                'dark_Textgrey--text': $vuetify.theme.dark,
              }"
              class="modal-logout"
              @click="logout"
            >
              {{ $t('common.logout') }}
            </a>
          </div>
        </div>

        <div class="mt-8 px-2 pb-3">
          <h2 class="my-2" :class="{ 'white--text': $vuetify.theme.dark }">
            {{ $t('views.privacyPolicyModal.title') }}
          </h2>

          <div class="my-4 modal-description">
            {{ $t('views.privacyPolicyModal.description') }}
          </div>

          <div class="privacy-policy mt-6">
            <v-checkbox v-model="privacyPolicyAccepted" hide-details>
              <template v-slot:label>
                <span>
                  {{ $t('views.signup.privacyPolicy.agree1') }}
                  <a
                    target="_blank"
                    class="links"
                    href="https://www.filios.app/aviso-legal-terminos-y-condiciones"
                    @click.stop
                  >
                    {{ $t('views.signup.privacyPolicy.terms') }}
                  </a>
                  {{ $t('views.signup.privacyPolicy.agree2') }}
                  <a
                    target="_blank"
                    class="links"
                    href="https://www.filios.app/politica-de-privacidad"
                    @click.stop
                  >
                    {{ $t('views.signup.privacyPolicy.privacyPolicy') }}
                  </a>
                </span>
              </template>
            </v-checkbox>
          </div>

          <div class="mt-5">
            <v-btn
              color="primary"
              :loading="loading"
              :disabled="!privacyPolicyAccepted"
              class="submit-button elevation-0 mt-2"
              @click="save"
            >
              {{ $t('common.save') }}
            </v-btn>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { acceptPrivacyPolicy } from '@/lib/api.js'
import LanguageSelector from '@/views/components/core/LanguageSelector'

export default {
  components: {
    LanguageSelector,
  },
  data: () => ({
    isModalActive: false,
    loading: false,
    privacyPolicyAccepted: false,
  }),
  computed: {
    ...mapState(['user']),
  },
  watch: {
    user: {
      handler() {
        if (this.user && this.user.status !== 'NOT_WELCOMED' && !this.user.privacyPolicyAccepted) {
          this.isModalActive = true
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      updateUsersInfo: 'UPDATE_USERS_INFO',
      logout: 'LOGOUT',
    }),
    async save() {
      try {
        this.loading = true
        await acceptPrivacyPolicy({ uid: this.user.uid })
        await this.updateUsersInfo()
        this.isModalActive = false
      } catch (error) {
        this.$root.$snackbar.error({ text: this.$t('common.commonError') })
      }
      this.loading = false
    },
  },
}
</script>

<style lang="scss">
#privacy-policy-modal {
  .items-flex {
    display: flex;
    &.justify-between {
      justify-content: space-between;
    }
  }
  .modal-logout {
    font-size: 14px;
  }
  .links {
    text-decoration: none;
  }
  .modal-description {
    font-size: 14px;
  }
  h1 {
    font-size: 22px;
    font-weight: 600;
  }
  .submit-button {
    width: 100%;
  }
}
</style>
